export const common = {
    requestProcessFail: '请求处理失败',
    requestFail: '请求失败',
    networkError: '网络请求失败，请稍后再试',
    notFound: '请求地址不存在',
    serverError: '服务器内部错误',
    selectCountry: '请选择国家',
    confirmed: '已确认',
    cancelled: '已取消...',
    back: '返回',
};

export const homePage = {
    alreadyUse: '已用',
    remain: '剩余',
    search: '搜索',
    findIccid: '如何查找 ICCID',
    fillIccid: '填写 SIM 卡 ICCID 号码',
    fillIccid1: 'ICCID 号码',
    changeLanguage: '切换语言',
    confirm: '确认',
    selectLanguage: '请选择语言',
    selectImageFile: '请选择图片文件',
    processing: '处理中...',
    recognizeSuccess: '识别成功',
    recognizeFail: '识别失败，请重试',
    recognizeEmpty: '未识别到 ICCID',
    compressFail: '压缩失败',
    takePhoto: '拍照',
    fromAlbum: '从相册选择',
    recognizing: '正在尝试识别....',
    openingCamera: '正在调用摄像头...',
    cameraFail: '摄像头调用失败',
    scanFail: '识别失败，请对准二维码',
};

export const planPage = {
    purchaseTitle: '购买套餐',
};

export const h = {
    login: "登录",
};

export const payPage = {
    paymentConfirm: '支付确认',
    payPackage: '套餐',
    payDuration: '时长',
    payTotal: '合计',
    paySelectPayment: '选择支付方式',
    payCardBankCredit: '银行卡 / 信用卡',
    cardSupportHint: '支持 Visa、Mastercard、Apple Pay、Google Pay',
    currentSelected: '当前选择',
    autoBadge: '自动',
    subscribeCardDeduct: '信用卡 / 借记卡订阅扣款',
    subscribeEwalletDeduct: '电子钱包订阅扣款',
    payOnceTitle: '单次支付',
    payOnceDesc: '单次支付，不会自动续费；一行一个支付方式。',
    rechargeEwalletDesc: '电子钱包单次支付',
    rechargeQrisDesc: '扫码支付',
    rechargeBankDesc: '银行转账单次支付',
    rechargeRetailDesc: '便利店支付',
    payComfirm: '确认支付',
    paymentSecureHint: '您的支付信息已安全加密。',
    inputContact: '请填写联系方式',
    contactAppNumber: '{app} 号码',
    contactUpdateViaApp: '订单更新将通过 {app} 发送',
    contactPhonePlaceholder: '请输入号码',
    contactPhoneMinLength: '号码不能少于8位',
    couponDeductLabel: '优惠券抵扣',
    amountAfterDeduction: '抵扣后的金额',
    orderCouponLoading: '优惠券加载中...',
    couponAppliedSub: '已用于本订单',
    couponAvailableSub: '可用于本订单',
    subscribePolicySection2Title: '订阅取消操作指南',
    subscribePolicyS2Step1Label: '步骤 1',
    subscribePolicyS2Step1: '到4G页面',
    subscribePolicyS2Step2Label: '步骤 2',
    subscribePolicyS2Step2: '找到订阅按钮',
    subscribePolicyS2Step3Label: '步骤 3',
    subscribePolicyS2Step3: '点击「关闭自动续费」',
    subscribePolicyS2Step4Label: '步骤 4',
    subscribePolicyS2Step4: '确认取消操作',
    subscribePolicyS2Tip: '在当前订阅周期结束前，你仍可正常使用本服务。',
    subscribeDetailTitle: '自动续订详情',
    subscribeDetailSubtitle: '查看计费周期、续费规则、取消方式等',
    refundSummaryTitle: '退款政策摘要',
    refundSummarySubtitle: '查看退款条件、流程及例外情况',
    xenditSubscribeNoticeTitle: '重要提示',
    xenditSubscribeNotice1: '您正在29日至31日之间订阅。',
    xenditSubscribeNotice2Prefix: '您的订阅将成功，但实际扣款将推迟至',
    xenditSubscribeNotice2Highlight: '下月1日。',
    xenditSubscribeNotice3: '我们将为您提供此期间的免费使用天数。扣款成功后，您的套餐天数将自动延长。',
    xenditSubscribeNoticeConfirm: '知道了',
    selectPaymentRequired: '请选择支付方式',
    paymentLinkInvalid: '支付链接无效',
    redirectPaymentFailed: '跳转支付页面失败，请手动操作',
    createOrderFailed: '创建订单失败',
    creatingOrder: '正在创建支付订单...',
    paymentComponentLoadFailedRefresh: '支付组件加载失败，请刷新页面',
    paymentComponentLoadFailed: '支付组件加载失败',
    paymentFailed: '支付失败',
    paymentCancelled: '支付已取消',
    paymentInitFailed: '支付初始化失败',
    indonesiaPhoneInvalid: '格式不对，请输入正确的印尼手机号',
};

export const paySuccessPage = {
    pendingResult: "订单待处理结果",
    activationSuccess: "您的 SIM 卡激活已成功提交",
    activationQuery: "激活状态查询",
    pendingPaymentTitle: "订单待付款",
    orderNoLabel: "订单号",
    redirectingPayment: "正在跳转支付...",
    pay: "付款",
    orderNoMissing: "缺少订单号",
    paymentLinkInvalid: "支付链接无效",
};

export const feedbackPage = {
    title: '反馈',
    heroTitle: '告诉我们发生了什么',
    heroSubtitle: '我们会尽快为您提供帮助。',
    ticketHistory: '我的工单记录',
    problemCategory: '问题分类',
    issueSelectTitle: '请选择具体问题',
    issueSelectSubtitle: '请选择最符合您情况的一项。',
    next: '下一步',
    form: {
        describeTitle: '描述您的问题',
        describeSubtitle: '请提供更多关于您所遇到问题的详细信息。',
        describePlaceholder: '请在此描述您的问题...（最多500字）',
        uploadPhotoTitle: '上传照片（可选）',
        uploadPhotoSubtitle: '最多可上传3张图片',
        uploadScreenshotTitle: '上传截图（可选）',
        uploadScreenshotSubtitle: '帮助我们更好地了解问题',
        contactEmailTitle: '联系邮箱',
        contactEmailPlaceholder: 'example@email.com',
        orderNoTitle: '订单号',
        orderNoPlaceholder: '请输入订单号',
        orderNoRequired: '请填写订单号',
        takePhoto: '拍照',
        chooseFromAlbum: '从相册选择',
        cancel: '取消',
        emailRequired: '请填写联系邮箱',
        emailInvalid: '请输入有效的邮箱地址',
        describeRequired: '请描述您的问题',
        iccidRequired: '缺少 ICCID，无法提交',
        uploading: '上传中...',
        uploadFailed: '图片上传失败，请重试',
        submitting: '提交中...',
        submitFailed: '提交失败，请重试',
        confirmSelected: '您选择的是：',
        pleaseMakeSure: '请确认：',
        checkSimInserted: 'SIM 卡已正确插入',
        checkDataPlanActive: '您的流量套餐已激活',
        checkCameraPowered: '摄像头已开机',
        checkSignalStrength: '信号强度至少 2 格',
        checkRestartCamera: '尝试重启摄像头',
        confirmPrompt: '请确认以上问题',
        submit: '提交',
    },
    success: {
        title: '提交成功！',
        subtitle: '我们的支持团队已收到您的请求。',
        ticketNumber: '工单号',
        submitTime: '提交时间',
        responseTime: '我们将在 24 小时内（工作日）回复您。',
        statusCheck: '您可以在「我的工单」中查看状态。',
        myTickets: '我的工单',
        backToHome: '返回首页',
        copySuccess: '复制成功',
    },
    categories: {
        camera: { title: '摄像头', desc: '摄像头离线、无法查看、夜视等问题' },
        sim: { title: 'SIM / 网络', desc: '无网络、信号弱、SIM 卡问题' },
        recharge: { title: '充值 / 套餐', desc: '充值失败、套餐未更新、订阅退款' },
        data: { title: '流量使用', desc: '流量消耗过高、剩余流量不正确' },
        device: { title: '设备功能', desc: '移动侦测、云存储、录像、固件等' },
        order: { title: '订单与支付', desc: '支付失败、退款、发票' },
        other: { title: '其他', desc: '其他问题' },
    },
    issues: {
        camera_offline: '摄像头离线',
        cannot_view_live: '无法查看直播',
        playback_failed: '回放失败',
        night_vision: '夜视问题',
        motion_detection: '移动侦测',
        camera_restart: '摄像头重启',
        camera_not_added: '摄像头未添加',
        sim_not_activated: 'SIM 未激活',
        no_network: '无网络',
        weak_signal: '信号弱',
        roaming_issue: '漫游问题',
        sim_replacement: 'SIM 更换',
        cannot_detect_sim: '无法识别 SIM',
        '4g_not_working': '4G 无法使用',
        recharge_failed: '充值失败',
        recharge_not_effective: '充值成功但未生效',
        plan_not_updated: '套餐未更新',
        wrong_package: '套餐错误',
        auto_renewal: '自动续费',
        subscription: '订阅',
        refund: '退款',
        coupon: '优惠券',
        high_data_usage: '流量消耗过高',
        data_used_too_fast: '流量消耗过快',
        remaining_data_incorrect: '剩余流量不正确',
        usage_not_updated: '使用量未更新',
        need_usage_report: '需要用量报告',
        payment_failed: '支付失败',
        duplicate_payment: '重复支付',
        order_not_found: '找不到订单',
        invoice: '发票',
        discount: '折扣',
        cloud_storage: '云存储',
        recording: '录像',
        sd_card: 'SD 卡',
        notification: '通知',
        firmware_upgrade: '固件升级',
        device_binding: '设备绑定',
        qr_code: '二维码',
        reset_device: '重置设备',
        other: '其他',
    },
    history: {
        tabs: { all: '全部', processing: '处理中', waiting: '等待中', resolved: '已解决', closed: '已关闭' },
        status: { processing: '处理中', waiting: '等待中', resolved: '已解决', closed: '已关闭' },
        deviceId: '设备 ID',
        iccid: 'ICCID',
        submitTime: '提交时间',
        empty: '暂无信息',
        loading: '加载中...',
        detailTitle: '工单详情',
        ticketNo: '工单号',
        issueType: '问题类型',
        description: '问题描述',
        photos: '相关图片',
        email: '联系邮箱',
        reply: '处理回复',
        loadFailed: '加载详情失败，请重试',
    },
};
